'use strict';

import { io, http, mq, config, history } from 'core';

import 'fetch';

console.log('app:bound');



// WEBPACK FOOTER //
// ./app/bind.js